export const SERVER_ADDRESS = `https://admin.iconstoolkit.com/backend`
// export const SERVER_ADDRESS = `http://localhost:3001`;
